// import { loadBotao, postFetch, tooglePassword } from "./utilidades";
import { loadBotao } from "./utilidades/loadBotao";
import { postFetch } from "./utilidades/postFetch";
import { tooglePassword } from "./utilidades/tooglePassword";
import JustValidate from "just-validate";
import { Report } from 'notiflix/build/notiflix-report-aio';
import { loadFullPage } from './utilidades/loadFullPage';

import i18next from "i18next";
import { inicializarInternacionalizacao } from "./localizacao/login-nova-senha/login-nova-senha";
import { removeCacheUsuarioLogado } from './utilidades/usuarioLogado';


const recuperarSenha = function () {

    const $form = document.getElementById('form-recuperar-senha');
    const botaoSolicitar = document.getElementById('btn-alterar-senha');
    const _call = async () => {
        loadBotao.mostrar(botaoSolicitar);
        removeCacheUsuarioLogado();

        const callbackSucesso = (resultado) => {
            loadBotao.esconder(botaoSolicitar);

            Report.success(
                i18next.t('RecuperarSenhaSucesso'),
                '',
                i18next.t('RecuperarSenhaSucessoAcessarConta'),
                () => {
                    loadFullPage.mostrar();
                    window.location.href = resultado.Redirect;
                }
            );

        }
        const callbackErro = (resultado) => {
            loadBotao.esconder(botaoSolicitar);

            let $rowErro = $form.querySelector('#row-erro');
            $rowErro.classList.remove('d-none');
            $rowErro.querySelector('.retorno-mensagem').innerHTML = resultado.mensagem;
        }

        await postFetch(`/${CULTURE_EMPREGARE}/Login/NovaSenha`, new FormData($form), callbackSucesso, callbackErro, callbackErro);

    };





    var init = function () {
        inicializarInternacionalizacao();
        const validar = new JustValidate($form, {
            errorFieldCssClass: "is-invalid"
        });
        validar
            .addField("#nova-senha", [
                {
                    rule: "minLength",
                    value: 4,
                    errorMessage: i18next.t('FormularioValidacaoMinimoDigitos'),
                },
                {
                    rule: "maxLength",
                    value: 25,
                    errorMessage: i18next.t('FormularioValidacaoMaximoDigitos'),
                },
                {
                    rule: "required",
                    errorMessage: i18next.t('FormularioValidacaoNovaSenha'),
                },
            ])
            .addField('#confirma-senha',
                [
                    {
                        validator: (value, fields) => {
                            let valido = false;

                            for (const fieldKey of Object.keys(fields)) {
                                if (fields[fieldKey].elem.getAttribute('id') !== 'nova-senha') {
                                    continue;
                                }

                                if (fields[fieldKey].elem.value === '' || fields[fieldKey].elem.value !== value) {
                                    valido = false;
                                } else {
                                    valido = true;
                                }
                            }

                            return valido;
                        },
                        errorMessage: i18next.t('FormularioValidacaoConfirmacaoSenha')
                    },
                ]);

        tooglePassword($form.querySelector('#nova-senha'), $form.querySelector('#novaSenhaIcon'));
        tooglePassword($form.querySelector('#confirma-senha'), $form.querySelector('#confirmaNovaSenhaIcon'));


        $form.addEventListener('submit', function (e) {
            $form.querySelector('#row-sucesso').classList.add('d-none');
            $form.querySelector('#row-erro').classList.add('d-none');

            validar.revalidate().then((isValid) => {
                if (isValid) {
                    _call();
                }
            });
            e.preventDefault();
        }, false);
    }
    return init();
}

recuperarSenha();